var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.847656 0C0.355469 0 0.109375 0.601562 0.464844 0.957031L3.96484 4.45703C4.18359 4.67578 4.53906 4.67578 4.75781 4.45703L8.25781 0.957031C8.61328 0.601562 8.36719 0 7.875 0H0.847656Z",
    fill: "#DC3545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownRed);
export default __webpack_public_path__ + "static/media/dropdown-red.2534d674.svg";
export { ForwardRef as ReactComponent };